import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import Content from './components/Content';
import Website from './components/Website';
import Wrapper from './styled';
import SeverityRange from 'Common/Components/SeverityRange';
import { STEP_VALUES } from 'Common/Components/SeverityRange/constants';

const ToolParams = ({ defaultParams, currentTool, onChangeField, severityRange, setSeverityRange }) => {
  const [tool, setTool] = useState(currentTool);

  useEffect(() => {
    setTool(currentTool);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTool?.name]);

  const handleChangeSeverity = (range) => {
    const min = STEP_VALUES.find((sev) => sev.value === range[0]);
    const max = STEP_VALUES.find((sev) => sev.value === range[1]);
    setSeverityRange({
      min: { value: min.value, severity: min.parsedSeverity },
      max: { value: max.value, severity: max.parsedSeverity }
    });
  };

  if (isEmpty(currentTool)) return null;

  return (
    <Wrapper>
      <Website currentTool={ tool } />
      { severityRange &&
        <SeverityRange
          defaultMin= { severityRange.min.value }
          defaultMax={ severityRange.max.value }
          onChange={ handleChangeSeverity }
        />
      }
      <Content defaultParams={ defaultParams } currentTool={ tool } onChangeField={ onChangeField } />
    </Wrapper>
  );
};

export default ToolParams;
